export default {
  CUSTOMER_PERSONAL_INFORMATION_REPOSITORY:
    Symbol.for('CUSTOMER_PERSONAL_INFORMATION_REPOSITORY'),
  CUSTOMER_PERSONAL_INFORMATION_STATE_MANAGER:
    Symbol.for('CUSTOMER_PERSONAL_INFORMATION_STATE_MANAGER'),
  GET_CUSTOMER_PERSONAL_INFORMATION_QUERY:
    Symbol.for('GET_CUSTOMER_PERSONAL_INFORMATION_QUERY'),
};
